import { createContext, useContext } from 'react';

/**
 * Set of AGENT_QUESTION activity log IDs that have been "answered" —
 * i.e., a Note or another activity exists after them in the timeline.
 * Questions in this set should hide their option buttons.
 */
const AnsweredQuestionsContext = createContext<Set<string>>(new Set());

export const AnsweredQuestionsProvider = AnsweredQuestionsContext.Provider;

export function useIsQuestionAnswered(activityLogId: string): boolean {
  return useContext(AnsweredQuestionsContext).has(activityLogId);
}
